import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { episodeOfCareAction } from '../../actions/constant';
import episodeOfCareService from '../../../services/apiServices/episodeOfCare/episodeOfCare';
const {
  GET_SINGLE_EPISODE_OF_CARE_REQUEST,
  GET_SINGLE_EPISODE_OF_CARE_SUCCESS,
  GET_SINGLE_EPISODE_OF_CARE_FAILURE,
  GET_SINGLE_EPISODE_OF_CARE_LOADING
} = episodeOfCareAction;

function* getSingleEpisodeOfCare(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_SINGLE_EPISODE_OF_CARE_LOADING });
    const response = yield call(episodeOfCareService.getSingleEpisodeOfCare, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_SINGLE_EPISODE_OF_CARE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SINGLE_EPISODE_OF_CARE_FAILURE, payload: error });
  }
}

function* getSingleEpisodeOfCareSaga() {
  yield takeEvery(GET_SINGLE_EPISODE_OF_CARE_REQUEST,getSingleEpisodeOfCare)
}

export default getSingleEpisodeOfCareSaga;
